import { Component, OnInit, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { RulesComponent } from '../rules/rules.component';
import { DOCUMENT_RULES_UI_SECTIONS } from '../model/quality.constant';
import { SubContentService } from '@cv-invision/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VirtualTourState } from './state/virtual-tour.state';
import { Store} from '@ngxs/store';
import { RuleEngine } from '../rules/model/rule-engine';

@Component({
	selector: 'cv-virtual-tour',
	templateUrl: './virtual-tour.component.html',
	styleUrls: ['./virtual-tour.component.scss']
})
export class VirtualTourComponent implements OnInit, OnDestroy {
	urlSafe: SafeResourceUrl;
	isAvailable: boolean;
	virtualLink$: Observable<any> = this.store.select(VirtualTourState.getVirtualTourCollection);
	private atComponentDestroy = new Subject();
	constructor(
		private store: Store,
		private subContentService: SubContentService,
		private componentFactoryResolver: ComponentFactoryResolver,
		public sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		RuleEngine.setSelectedSection(this.store, DOCUMENT_RULES_UI_SECTIONS.VIRTUALTOUR);

		this.virtualLink$.pipe(takeUntil(this.atComponentDestroy)).subscribe((vl: Array<any>) => {
			if (vl && vl.length) {
				const { path } = vl[0];
				this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(path);
				this.isAvailable = true;
			} else {
				this.isAvailable = false;
			}
		});
	}

	/**
	 * Load the Virtual tour Rules through store managment and then open the Rules SubContent panel.
	 */
	private loadVirtualTourRules(): void {
		this.subContentService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RulesComponent,
				data: {
					uiSection: DOCUMENT_RULES_UI_SECTIONS.VIRTUALTOUR
				}
			})
			.subscribe();
	}

	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
